<template>
  <div class="row" v-if="schedule && schedule.statistics">
        <div class="col-xxl-4 col-xl-4 col-sm-12">
          <div
            class="card bg-primary bg-opacity-10 border-primary border-opacity-10 rounded-3 mb-4 stats-box style-three"
          >
            <div class="card-body p-4">
              <div class="d-flex align-items-center mb-19">
                <div class="flex-shrink-0">
                  <i class="material-symbols-outlined fs-40 text-primary">
                    calculate
                  </i>
                </div>
                <div class="flex-grow-1 ms-2">
                  <span v-html="t('fr.liquidity.avg_monthly_rate', 'La tua rata mensile con Smart Rate')"></span>
                  <h3 class="fs-20 mt-1 mb-0 text-default">{{ formatCurrency(schedule.metadata.avgRate) }}</h3>
                </div>
              </div>
              <div
                class="d-flex justify-content-between flex-wrap gap-2 align-items-center d-none"
              >

               <!-- <span class="fs-12">Min: {{ formatCurrency(schedule.metadata.minRate) }}</span>
                <span class="fs-12">Max: {{ formatCurrency(schedule.metadata.maxRate) }}</span> -->
              <span></span>
  
                <span class="count countnostyle fw-medium ms-0">{{ schedule.events.length }} rate</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xxl-4 col-xl-4 col-sm-6">
          <div
            class="card bg-success bg-opacity-10 border-success border-opacity-10 rounded-3 mb-4 stats-box style-three"
          >
            <div class="card-body p-4">
              <div class="d-flex align-items-center mb-19">
                <div class="flex-shrink-0">
                  <i class="material-symbols-outlined fs-40 text-success">
                    savings
                  </i>
                </div>
                <div class="flex-grow-1 ms-2">
                  <span v-html="t('fr.liquidity.total_deposits', 'Totale Versamenti')"></span>
                  <h3 class="fs-20 mt-1 mb-0 text-default">{{ formatCurrency(schedule.statistics.totalDeposits) }}</h3>
                </div>
              </div>
              <div
                class="d-flex justify-content-between flex-wrap gap-2 align-items-center d-none"
              >
                <span class="fs-12">Projects this month</span>
                <span class="count countnostyle fw-medium ms-0">+5.75%</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xxl-4 col-xl-4 col-sm-6">
          <div
            class="card bg-danger bg-opacity-10 border-danger border-opacity-10 rounded-3 mb-4 stats-box style-three"
          >
            <div class="card-body p-4">
              <div class="d-flex align-items-center mb-19">
                <div class="flex-shrink-0">
                  <i class="material-symbols-outlined fs-40 text-danger">
                    payments
                  </i>
                </div>
                <div class="flex-grow-1 ms-2">
                  <span v-html="t('fr.liquidity.total_payments', 'Totale Pagamenti')"></span>
                  <h3 class="fs-20 mt-1 mb-0 text-default">{{ formatCurrency(schedule.statistics.totalPayments) }}</h3>
                </div>
              </div>
              <div
                class="d-flex justify-content-between flex-wrap gap-2 align-items-center d-none"
              >
                <span class="fs-12">Projects this month</span>
                <span class="count countnostyle fw-medium ms-0">-15%</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xxl-2 col-xl-2 col-sm-6 d-none">
          <div
            class="card bg-primary-div bg-opacity-10 border-primary-div border-opacity-10 rounded-3 mb-4 stats-box style-three"
          >
            <div class="card-body p-4">
              <div class="d-flex align-items-center mb-19">
                <div class="flex-shrink-0">
                  <i class="material-symbols-outlined fs-40 text-primary-div">
                    assignment_turned_in
                  </i>
                </div>
                <div class="flex-grow-1 ms-2">
                  <span v-html="t('fr.liquidity.final_balance', 'Saldo Finale Previsto')"></span>
                  <h3 class="fs-20 mt-1 mb-0 text-default">{{ formatCurrency(schedule.statistics.finalBalance) }}</h3>
                </div>
              </div>
              <div
                class="d-flex justify-content-between flex-wrap gap-2 align-items-center d-none"
              >
                <span class="fs-12">Projects this month</span>
                <span class="count countnostyle fw-medium ms-0">-15%</span>
              </div>
            </div>
          </div>
        </div>
      </div>

</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "ProjectsOverview",
});
</script>



<script setup lang="ts">
import { defineProps } from 'vue';
import { t } from '@/utils/i18nHelper';

const props = defineProps({
  schedule: {
    type: Object,
    required: true,
  },
});

const formatCurrency = (amount: number) => {
  // Se il valore è zero (o molto vicino a zero), forza 0 per evitare -0,00
  const normalizedAmount = Math.abs(amount) < 0.01 ? 0 : amount;

  return new Intl.NumberFormat('it-IT', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(normalizedAmount);
};
</script>

<style scoped>
/* Add any specific styles here */

.stats-box .count.countnostyle {
    background-color: #6262620e;
    border-color: #62626227;
    color: rgba(0, 0, 0, 0.424);
}
</style>